module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_fitness-c78e8fd4321f9283788bad343d02bf4c.png";